/*
Extrusion Pulls
  --length | length of the pieces that are ordered
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Extrusion'
const id = 'aavSIGdsfQdzCTRrYe0b'

export default {
  name,
  id,
  filters,
  headers,
  form
}
